$( document ).ready(function() {

    if(document.location.hash == '#succ-add-to-cart'){
        setTimeout(function() {
            //$('.header__btn-cart a').click();
        }, 500);
    }

    $('.constructor_add_product').on('click', function(){

        $('.discount-note').hide();

        var product_title    = $(this).data('product-title');
        var product_image    = $(this).data('product-image');
        var product_id       = $(this).data('product-id');
        var product_price    = $(this).data('product-price');
        var constructor_step = $('#constructor_step').val();

        $('#clear_constructor').fadeIn(800);

        if($(this).hasClass('is-disabled')){
            var enable_product_id = $(this).data('product-id');
            $('#constructor_step').val((constructor_step * 1) - 1);
            var counter = 1;
            $('.faves-stack-product').each(function(){
                if($(this).data('product-id') == enable_product_id){
                    $(this).find('.faves-stack-product__img-number').empty().text(counter);
                    $(this).find('.faves-stack-product__title').empty().text('Product ' + counter);
                }
                counter++;
            });
        }

        var constructor_step_check1 = $('#constructor_step').val();
        if(constructor_step_check1<4) {
            if($(this).hasClass('is-disabled')) {
                $('.faves-stack__price-normal').text('');
                $('.faves-stack__price-discounted').text('');
                $(this).removeClass('is-disabled');
                $('#constructor_add_to_cart').removeClass('active-add-to-cart-button');
            }else{
                $(this).addClass('is-disabled');
                $('#constructor_block_' + constructor_step).attr('data-product-id', product_id).attr('data-product-price', product_price);
                $('#constructor_block_' + constructor_step + ' .faves-stack-product__title').text(product_title);
                $('#constructor_block_' + constructor_step + ' .faves-stack-product__img-number').empty().html('<img class="constructor-product-image" style="display:none" src="' + product_image + '"/>');
                $('#constructor_step').val((constructor_step * 1) + 1);
                $('#constructor_block_' + constructor_step + ' .faves-stack-product__img-number img').fadeIn(800);
            }
        }

        var constructor_step_check = $('#constructor_step').val();

        if(constructor_step_check == 1){
            $('#clear_constructor').fadeOut(800);
        }

        if(constructor_step_check == 4){
            $('.discount-note').fadeIn(800);
            $('#constructor_add_to_cart').addClass('active-add-to-cart-button');
            landingShowDiscountPrice();
        }
    });
});

function landingAddToCartConstructor() {
   if($('#constructor_add_to_cart').hasClass('active-add-to-cart-button')){

       $('#constructor_add_to_cart').text('Please wait...').removeClass('active-add-to-cart-button');
       $('#clear_constructor').fadeOut(800);

       setTimeout(function() {
           var count_add = 0;
           $('.faves-stack-product').each(function () {
               var variant_id = $(this).data('product-id');
               if (variant_id) {
                   landingAjaxAddToCart(variant_id);
                   sleepConstructor(1500);
               }
               count_add++;

               if (count_add == 3) {
                   document.location.href = '/cart';
               }
           });
       }, 500);

       //setTimeout(function(){
          // document.location.href = '/cart';
      // },4000);
   }
}

function sleepConstructor(milliseconds) {
    const date = Date.now();
    let currentDate = null;
    do {
        currentDate = Date.now();
    } while (currentDate - date < milliseconds);
}

function landingAjaxAddToCart(variant_id) {
    var data = {
        "id": variant_id,
        "quantity": 1
    }

    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function () {
        },
        error: function (error) {
            alert(error.responseJSON.message + '\r\n' + error.responseJSON.description);
        }
    });
}

function landingShowDiscountPrice() {
    var block_price_normal = $('.faves-stack__price-normal');
    var block_price_discounted = $('.faves-stack__price-discounted');

    var product_total_price = 0;
    $('.faves-stack-product').each(function(){
        product_total_price = product_total_price + ($(this).data('product-price')/100);
    });

    var product_total_price_with_discount = (product_total_price/100)*discount_bundle;
    product_total_price_with_discount = product_total_price-product_total_price_with_discount;

    block_price_normal.text('$' + product_total_price.toFixed(2) );
    block_price_discounted.text('$' + product_total_price_with_discount.toFixed(2) );
}

function landingClearConstructor() {
    var i = 1;

    $('.faves-stack-product').each(function(){
        $(this).find('.faves-stack-product__title').empty().text('Product' + ' ' + i);
        $(this).find('.faves-stack-product__img-number').empty().text(i);
        i++;
    });
    $('#constructor_step').val(1);
    $('#clear_constructor').fadeOut(800);
    $('.constructor_add_product').removeClass('is-disabled');
    $('#constructor_add_to_cart').removeClass('active-add-to-cart-button');
    $('.faves-stack__price-normal').text('$AAA');
    $('.faves-stack__price-discounted').text('$BBB');
}